import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { StorageService } from '../services/storage.service';

/**
 * Guard qui vérifie que l'utilisateur est authentifié ET a le profil 'etudiant'
 * Redirige vers la page de login si non authentifié ou profil incorrect
 */
export const etudiantGuard: CanActivateFn = async (route, state) => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  // Vérifier si l'utilisateur est authentifié
  if (!storageService.isAuthenticated()) {
    console.log('[EtudiantGuard] Utilisateur non authentifié, redirection vers /login');
    router.navigate(['/login'], {
      queryParams: { returnUrl: state.url }
    });
    return false;
  }

  // Récupérer l'utilisateur depuis le storage
  const user = storageService.getUser();

  if (!user) {
    console.log('[EtudiantGuard] Données utilisateur non trouvées, redirection vers /login');
    storageService.clearAuth();
    router.navigate(['/login'], {
      queryParams: { returnUrl: state.url }
    });
    return false;
  }

  // Vérifier que l'utilisateur a le profil 'etudiant' (support multi-profils)
  const hasEtudiantProfil = user.profils?.some(p => p.code === 'etudiant');

  if (!hasEtudiantProfil) {
    const userProfils = user.profils?.map(p => p.code).join(', ') || 'aucun';
    console.log(`[EtudiantGuard] Profil 'etudiant' requis, profils actuels: ${userProfils}, accès refusé`);
    router.navigate(['/home'], {
      queryParams: { error: 'access_denied' }
    });
    return false;
  }

  console.log('[EtudiantGuard] Accès autorisé pour profil etudiant');
  return true;
};
